<template>
  <div>
    <page-loading v-if="!item" />
    <page-title v-if="item" :title="pageTitle" />
    <station-scales :scale-set="item" v-if="item" :is-editable="true" :no-master-warnings="true">
    </station-scales>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "ScaleSetEdit",
  mixins: [CrudOperationsMixin],
  props: {},
  data() {
    return {
      item: null
    };
  },
  computed: {
    pageTitle: function () {
      return 'Edit Master Concentration Scale';
    },
  },
  methods: {
    load: function () {

      this.readQuery('/graphql/management', {
          query: `
            query ($filter: String) {
              scaleSets (filter: $filter) {
                id,
                concurrencyCheck,
                isMaster,
                scales {
                  id,
                  category,
                  range1Begin,
                  range2Begin,
                  range3Begin,
                  range4Begin,
                  concurrencyCheck
                }
              }
            }`,
          variables: {
            'filter': 'isMaster=true'
          }
        }, (data) => {
          this.item = data.scaleSets[0];
        });
    },
  },
  mounted () {
    this.load();
    // Use this instead of the previous line to test the "Loading" bar
    //window.setTimeout(this.load, 3000);
  }
};
</script>